export const currency = {
    methods: {
        currencyFormat: (currencyCode, amount) => {
            const formatter = new Intl.NumberFormat('en-GB', {style: 'currency', currency: currencyCode})
            return formatter.format(amount / 100)
        },
    },
}
